import NavigationBarControl from '../../../lib/ui/NavigationBarControl'
import FileForm from '../ui/FileForm'
import FileModel from '../model/FileModel'

export default class EditFile {
  constructor (element, args) {
    this.onchange = () => {
      this.data = this.fileForm.getValue()
      window.PRIM.initDelayedNavigation()
      window.PRIM.dataAccess.put('files', this.data.getJSON()).then((file) => {
        if (!window.PRIM.isDelayedNavigationActive())
        {
          return
        }

        if (args && !args.id && file.id) {
          window.PRIM.navigate('/files/' + file.id)
          return
        }

        this.data.values.id = file.id
        this.fileForm.setValue(this.data)
      }).catch(window.PRIM.exceptionHandler)
    }

    if (args && args.id) {
      window.PRIM.dataAccess.resolve('files', args.id, true).then((file) => {
        this.data = file
        this.fileForm.setValue(this.data)
      }, () => {
        if (confirm('Dit bestand bestaat niet, mogelijk is deze intussen verwijderd. Wilt u een nieuw bestand aanmaken?')) {
          window.PRIM.navigate('/files/')
        } else {
          history.back()
        }
      }).catch(window.PRIM.exceptionHandler)
    }

    this.data = new FileModel()

    let fragment = document.createDocumentFragment()
    new NavigationBarControl(fragment, {
      title: 'Bestand bewerken',
      leftHandButtons: [{
        onclick: () => {
          history.back()
        },
        icon: '\ue00d'
      },
        {
          onclick: () => {
            history.forward()
          },
          icon: '\ue01a'
        },
        {
          onclick: () => {
            window.PRIM.navigate('/start/')
          },
          icon: '\ue08a'
        },
        {
          onclick: this.onchange,
          icon: '\ue020',
          classes: 'indicator'
        }],
      contextMenu: [        
        {
          onclick: () => {
            if (this.data.values.id) {
              if (confirm('Weet u het zeker dat u  bestand wilt verwijderen?')) {
                window.PRIM.dataAccess.delete('files', this.data.values.id).then(() => {
                  history.back()
                })
              }
            } else {
              alert('Vul eerst gegevens voor dit bestand.')
            }
          },
          icon: '\ue123',
          label: 'Verwijderen'
        }
      ]
    })

    let div = document.createElement('div')
    div.className = 'viewport'

    let divContent = document.createElement('div')
    divContent.className = 'content'

    this.fileForm = new FileForm(divContent, {file: this.data, onchange: this.onchange})

    div.appendChild(divContent)
    fragment.appendChild(div)

    element.appendChild(fragment)
  }
}



// WEBPACK FOOTER //
// ./js/modules/file/action/EditFile.js